module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {



filterGroups

.filter( filterGroup => {

	if ( filterGroup.skip ) {
		return false;
	}

	return ['checkbox', 'radio', 'pricerange', 'category'].includes( filterGroup.type );
})

.forEach( ( filterGroup ) => {

	const filters = filterGroup.filter || [];

	const activeFilters = filters.filter( filter => filter.selected );
	const selectedString = 'category' === filterGroup.type ? filterGroup.selected : activeFilters.slice( 0, 10 ).map( filter => filter.label || filter.value ).join( ', ' );

	let filterCount = filterGroup.count;
	if ( 'sortorder' === filterGroup.identifier ) {
		filterCount = 0;
	}

	let groupName = filterGroup.nameDe || filterGroup.name;
	if ( 'dynamic' === filterGroup.identifier ) {
		const split = groupName.split('|')
		groupName = split[1] || groupName;
	}
;
__p += '\n<li class="mdl_filter__overview-filter-item is-selected" data-identifier="' +
((__t = ( filterGroup.dynamic_identifier || filterGroup.identifier )) == null ? '' : __t) +
'">\n\n	';
 if ( 'checkbox' === filterGroup.type ) { ;
__p += '\n		<!-- Empty Input, so the value gets cleared, when empty have the correct name -->\n		<input type="hidden" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'[]" value="" />\n	';
 } ;
__p += '\n	';
 if ( 'category' === filterGroup.type ) { ;
__p += '\n		<!-- Empty Input, so the value gets cleared, when empty have the correct name -->\n		<input type="hidden" name="shop" value="shop" />\n	';
 } ;
__p += '\n	';
 if ( 'pricerange' === filterGroup.type || 'radio' === filterGroup.type ) { ;
__p += '\n		<!-- Empty Input, so the value gets cleared, when empty have the correct name -->\n		<input type="hidden" name="' +
((__t = ( filterGroup.input_name )) == null ? '' : __t) +
'" value="" />\n	';
 } ;
__p += '\n	';
 if ( filterGroup.multi ) { ;
__p += '\n		<!-- Empty Input, so the value gets cleared, when empty have the correct name -->\n		<input type="hidden" name="' +
((__t = ( filterGroup.multi )) == null ? '' : __t) +
'" value="" />\n	';
 } ;
__p += '\n\n	<button class="mdl_filter__overview-filter-item-trigger js_filter__overview-filter-item-trigger" type="button">\n\n		<span class="mdl_filter__overview-filter-item-inner">\n			<span class="mdl_filter__overview-filter-item-title-container">\n				<span class="mdl_filter__overview-filter-item-title">' +
((__t = ( groupName )) == null ? '' : __t) +
'</span>\n				';
 if ( filterCount > 0 ) { ;
__p += '\n				<span class="mdl_filter__overview-filter-item-count">' +
((__t = ( filterCount )) == null ? '' : __t) +
'</span>\n				';
 } ;
__p += '\n			</span>\n			<span class="mdl_filter__overview-filter-item-selection">' +
((__t = ( selectedString )) == null ? '' : __t) +
'</span>\n		</span>\n	</button>\n</li>\n';
 } ); ;
__p += '\n';

}
return __p
};
